/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { Component } from "react";

//COMPONENTS
import { NanoFlex } from "../../Elements/NanoFlex";
import Type from "../../Elements/Typography";
//UTILS
import { MonthLongStrings } from "../../../core/constants";

class MapHeader extends Component {
  timestamp() {
    const today = new Date();
    const day = today.getDate();
    const month = MonthLongStrings[today.getMonth()];
    const year = today.getFullYear();
    const time = today.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    return `${day} ${month} ${year}, ${time}`;
  }

  render() {
    return (
      <NanoFlex className="mapLegend">
        <NanoFlex
          flexDirection="column"
          flexWrap="nowrap"
          alignContent="flex-start"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Type.h4>Today´s map</Type.h4>
          <Type.p>As of {this.timestamp()}</Type.p>
        </NanoFlex>
        <NanoFlex
          flexDirection="row"
          flexWrap="nowrap"
          alignContent="flex-end"
          justifyContent="flex-end"
        >
          <Type.p>
            <b>Severity:</b>
          </Type.p>
          <NanoFlex width="auto">
            <NanoFlex
              color="red"
              radius="10px"
              padding="2px"
              margin="0 10px 0 15px"
              width="5px"
              height="5px"
            ></NanoFlex>
            <Type.p className="severityName">High</Type.p>
          </NanoFlex>
          <NanoFlex width="auto">
            <NanoFlex
              color="#FF8100"
              radius="10px"
              padding="2px"
              margin="0 10px 0 10px"
              width="5px"
              height="5px"
            ></NanoFlex>
            <Type.p className="severityName">Medium</Type.p>
          </NanoFlex>
          <NanoFlex width="auto">
            <NanoFlex
              color="#FFC107"
              radius="10px"
              padding="2px"
              margin="0 10px 0 10px"
              width="5px"
              height="5px"
            ></NanoFlex>
            <Type.p className="severityName">Low</Type.p>
          </NanoFlex>
        </NanoFlex>
      </NanoFlex>
    );
  }
}

export default MapHeader;
